import { render, staticRenderFns } from "./DefalutLayout.vue?vue&type=template&id=97aeeb54&"
import script from "./DefalutLayout.vue?vue&type=script&lang=js&"
export * from "./DefalutLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports